// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7f200c2","455":"74f24d9e"}[chunkId] + ".chunk.js";
};